<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <!-- Header Block -->
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin: 10px;border-radius: 10px;">

      <div class="">
        <div class="row">
          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
            <p class="my-auto ml-3" style="font-size: 20px;font-weight: 600;">Enter Month, Year & Case</p>
          </div>

          <div class="col-5 col-md-5 col-sm-12" style="margin: 10px;">
            <input class="w-50 m-2" type="month" name="month_year" [(ngModel)]="month_year" autofocus>

            <select class="w-50 m-2" name="caseValue" [(ngModel)]="caseValue" (change)="onSelected($event)">
              <option value="false" disabled>Select Case</option>
              <option *ngFor="let case of cases" [value]="case">{{case}}</option>
            </select>
          </div>
          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button type="button" class="btn btn-light" (click)="searchData()">Submit</button>
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
          </div>

        </div>

      </div>
    </div>
    <table class="table table-striped table-bordered text-center">
      <thead>
        <tr>
          <th scope="col" style="font-weight: bold">NDA Class</th>
          <th scope="col" style="font-weight: bold">Brand Name</th>
          <th scope="col" style="font-weight: bold">Error List</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of allData ; index as i">
          <tr>
            <!-- [attr.rowspan]="allData.length" -->
            <td>
              {{ data['NDA Number'] || '-' }}
            </td>
            <td>
              {{ data['Brand Name'] || '-'}}
            </td>
            <td>
          <tr *ngFor="let error of data['Error List']">
            <td>{{ error['error in which link'] || '-'}}</td>
            <td>{{ error['error']['message'] || '-'}}</td>
          </tr>
          </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>